import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';
import { PersonProfilePopup } from './model';
import { MaxLengthTooltip } from 'portcall/pctooltip/view';
import { PhoneNumberView } from 'portcall/phonenumber/view';
import { PCBounded } from 'portcall/pcbounded/view';
import { PCDismissible } from 'portcall/pcdismissible/view';
import * as cx from 'classnames';

// character limits at which tooltips will be enabled
const MAX_NAME_CHARS = 20,
    MAX_ORG_CHARS = 28,
    MAX_EMAIL_CHARS = 25;

export let PersonProfilePopupView = SuperCritical(({ modelContainer, boundingContainer, boundingPadding } : { modelContainer : () => PersonProfilePopup | null, boundingContainer? : string, boundingPadding? : number }) => {
    let m = modelContainer();
    if (!m) return null!;
    return (
        <PCBounded className="personprofilepopup pc-card"
            container={boundingContainer || '.pc-page-fixedwidth'}
            padding={boundingPadding !== undefined ? boundingPadding : 10}>
            <PCDismissible onDismiss={m.HidePopup}>
                {/*<loadingindicator params="request: Request" />*/}
                <img className="profile-image" src={m.User() && m.User()!.Model.Image.ProfileUrl() || ''} />
                <div className="right-side">
                    <a href="" className="dismiss-btn" onClick={noDefault(m.HidePopup)}>
                        <span className="pc-close-icon"></span>
                    </a>
                    <ProfileDetails model={m} />
                    <FullProfileLink model={m} />
                </div>
            </PCDismissible>
        </PCBounded>
    );
});

export let ProfileDetails = SuperCritical(({ model: m } : { model : PersonProfilePopup }) =>
    <div className="profile-details">
        <UserNameView model={m} />
        <OrganizationNameView model={m} />
        <EmailView model={m} />
        <ContactsView model={m} />
    </div>
);

export let UserNameView = SuperCritical(({ model: m } : { model : PersonProfilePopup }) =>
    <div className="name">
        {(user => user &&
            <MaxLengthTooltip className="name-text pc-text-fixedwidth pc-text-fixedwidth-tooltip"
                text={() => user.Model.FullName()}
                maxLength={MAX_NAME_CHARS} />
        )(m.User())}
    </div>
);

export let OrganizationNameView = SuperCritical(({ model: m } : { model : PersonProfilePopup }) => {
    let org = m.User() && m.User()!.Model.Organization();
    if (!org) return null!;
    return (
        <MaxLengthTooltip className="organization pc-text-fixedwidth pc-text-fixedwidth-tooltip pc-text-smalllabel"
            text={() => org!.Name() || ''} maxLength={MAX_ORG_CHARS} />
    );
});

export let EmailView = SuperCritical(({ model: m } : { model : PersonProfilePopup }) => {
    const pcuser = m.User(),
        user = pcuser && pcuser.Model.User(),
        email = user && user.Email() || '';
    return !email ? null :
        <div className="email">
            <span className="pc-text-smalllabel">email</span>
                <a href={"mailto:" + email}><MaxLengthTooltip className="email-text pc-text-fixedwidth pc-text-fixedwidth-tooltip"
                    text={() => email || ''} maxLength={MAX_EMAIL_CHARS} /></a>
        </div>;
});

export let ContactsView = SuperCritical(({ model: m} : { model : PersonProfilePopup }) => {
    let user = m.User();
    if (!user) return null!;
    return (
        <div className="contacts pc-show-viewcontrols">
            {user.OtherNumbers().length > 0 &&
                <a href="" className="more-btn" onClick={noDefault(user.ToggleMoreNumbers)}>more</a>
            }
            <div className="main-number">
                {user.MainNumber() && <PhoneNumberView model={user.MainNumber()!} />}
            </div>
            {user.OtherNumbers().length > 0 &&
                <div className="other-numbers pc-card" hidden={!user.ShowMoreNumbers()}>
                    {user.OtherNumbers().map(pn =>
                        <PhoneNumberView model={pn} key={pn.Model.Id()} />
                    )}
                </div>
            }
        </div>
    );
});

export let FullProfileLink = SuperCritical(({ model: m } : { model : PersonProfilePopup }) => {
    if (!m.Model.CanEdit()) return null!;
    return (
        <div className="view-full-profile">
            <a href={'#!personprofilepage?id=' + m.UserId}>
                View full profile
            </a>
        </div>
    );
});


// WEBPACK FOOTER //
// ./apps/portcall/personprofilepopup/view.tsx